import { render, staticRenderFns } from "./NarrativeKeyQuestion.vue?vue&type=template&id=48def13a&scoped=true&"
import script from "./NarrativeKeyQuestion.vue?vue&type=script&lang=js&"
export * from "./NarrativeKeyQuestion.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeKeyQuestion.vue?vue&type=style&index=0&id=48def13a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48def13a",
  null
  
)

export default component.exports